// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { merge } from 'lodash-es';
import { environment as ush_shared } from './ush.shared';

export const ush_prod = {
  adobeHeaderScript:
    '//assets.adobedtm.com/a2ef59fba8e9/665180b57410/launch-8f6789c0235b.min.js',
  digitalDataAngularVersion: '13.3.11',
  digitalDataEnvironment: 'PROD',
  digitalDataSite: 'UDX',
  diningReservationsAppPath: 'https://www.universalorlando.com/dining/',
  hmacKey: 'WOd9DF9xiF1Qj6zyO7Fayg5I7iA7XiQ31EAORzZpiOX4CjuCa8KSvN3T4eWeUzH8',
  mobileServicesApi: {
    baseUrl: 'https://services.universalorlando.com/api',
    key: 'TestingClient',
    token: '0DDA1406-3835-4953-9DE0-00001F3E98E8',
    city: 'Hollywood',
    cityCode: '',
    venueEndpoint: '/Venues',
    showTimesEndpoint: '/api/PointsOfInterest/Shows/ShowTimes',
  },
  oauthBaseUrl: 'https://api.universalparks.com',
  oauthClientKeyID: 'L6sJ5hC5aP2iD0gX7yI1dV0lS7pX0hN1jK8mK8pK7lV2uE3hD8',
  oidc: {
    client_id: 'f1fccd9c-9408-4c34-a425-4793742a4c47',
    client_secret: 'v6ikIdmNPsTFgnSCwf7b0LGqRDyHhaV4xt3rMKczp18OoXJAje',
    base_url: 'https://api.universalparks.com',
  },
  production: true,
  seoTitle: 'Universal Studios Hollywood - Los Angeles, California',
  webAppPath: 'https://www.universalstudioshollywood.com/web',
  webstoreAppPath: 'https://www.universalorlando.com/web-store',
  webstoreJunction: 'https://universalorlando.com',
  timeZone: 'America/New_York',
  COMPLETE_AP: 'https://apass-p-st.usj.co.jp/app/top.do',
  commerceApiUrl: 'https://comm-api.universaldestinationsandexperiences.com/',
  commerceClientId: 'mobile_android',
  commerceClientKeyID: 'mBl8RbG6tUU3XYn6PaYssg6Da8vrdPJJW67P4zH9klvXYTiQ8E',
  wtsHostBaseUrl: 'https://store2.universalstudioshollywood.com/',
  entitlementBaseUrl: 'https://api.universalparks.com',
  cookieSubDomain: '.universalstudioshollywood.com',
  contentApiBaseUrl: 'https://api.universalparks.com',
  contentLoginClientID: 'f1fccd9c-9408-4c34-a425-4793742a4c47',
  contentLoginClientKeyID: 'v6ikIdmNPsTFgnSCwf7b0LGqRDyHhaV4xt3rMKczp18OoXJAje',
  inquiryToken: '',
  oidcInquiryClientId: '',
  oidcInquiryClientKeyID: '',
  DINING_RESERVATION:
    'https://universalstudioshollywood.com/dining/en/us/dashboard',
};
export const environment = merge(ush_shared, ush_prod);
